class BESSAppProjectVisibilityDependencyHandler extends BESSAppProjectDependencyHandler {

    constructor(node, showHideCondition, showIfFn) {
        super();
        this.node = node;
        this.node.addClass('hidden');
        this.showHideCondition = showHideCondition;
        this.showIfFn = nullIfUndefined(showIfFn);
    }

    handle(event) {
        super.handle(event);
        let value = event.getValue();
        let showCondition = this.showHideCondition(value);
        if (this.showIfFn != null) {
            this.showIfFn(showCondition, event.changing, value);
        } else {
            this.node.showAnimatedIf(showCondition, event.changing);
        }
        BESSAppScreenLayoutChangedEvent.layoutHasChanged(this);
    }
}



